// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../images/sprite-images/', true, /\.svg$/));

const home = document.querySelector('.home');

if (home) {
  // ==========================
  // ACCESS SECTION INTERACTION
  // ==========================

  document.addEventListener('DOMContentLoaded', () => {
    const accessButtons = document.querySelectorAll('.access__item');
    const chevron = document.querySelector('.access__chevron');
    const positions = [70, 322, 570];
    const positionsResponsive = [54, 303, 550];
    const accessBodies = document.querySelectorAll('.access__body');
    const accessHead = document.querySelector('.access__head');
    const accessMain = document.querySelector('.access__main');
    const ACCESS_HEIGHT_OFFSET = 90;
    const ACCESS_MOBILE_MAX_WIDTH = 700;
    let accessMainHeightRaf = null;

    const updateAccessMainHeight = () => {
      if (!accessMain) {
        return;
      }

      if (window.innerWidth >= ACCESS_MOBILE_MAX_WIDTH) {
        accessMain.style.removeProperty('height');
        accessMain.style.removeProperty('min-height');
        return;
      }

      const openBody = document.querySelector('.access__body.access__body--open');
      if (!openBody) {
        accessMain.style.removeProperty('height');
        accessMain.style.removeProperty('min-height');
        return;
      }

      const openBodyHeight = Math.ceil(openBody.getBoundingClientRect().height) + ACCESS_HEIGHT_OFFSET;
      accessMain.style.height = `${openBodyHeight}px`;
      accessMain.style.minHeight = `${openBodyHeight}px`;
    };

    const scheduleAccessMainHeightUpdate = () => {
      if (accessMainHeightRaf !== null) {
        return;
      }
      accessMainHeightRaf = window.requestAnimationFrame(() => {
        accessMainHeightRaf = null;
        updateAccessMainHeight();
      });
    };

    if (window.ResizeObserver) {
      const accessBodiesObserver = new ResizeObserver(() => {
        scheduleAccessMainHeightUpdate();
      });
      accessBodies.forEach(body => accessBodiesObserver.observe(body));
    }

    function updateAccessBodiesState(activeIndex) {
      if (!accessBodies.length) {
        return;
      }

      const classesToReset = ['access__body--open', 'access__body--top', 'access__body--bottom'];
      accessBodies.forEach(body => {
        body.classList.remove(...classesToReset);
      });

      const targetBody = accessBodies[activeIndex] || accessBodies[0];
      const firstBody = accessBodies[0];
      const secondBody = accessBodies[1];
      const thirdBody = accessBodies[2];

      targetBody.classList.add('access__body--open');

      if (firstBody && activeIndex !== 0) {
        firstBody.classList.add('access__body--top');
      }

      if (thirdBody && activeIndex !== accessBodies.length - 1) {
        thirdBody.classList.add('access__body--bottom');
      }

      if (secondBody) {
        if (activeIndex === 0) {
          secondBody.classList.add('access__body--bottom');
        } else if (activeIndex === accessBodies.length - 1) {
          secondBody.classList.add('access__body--top');
        }
      }
    }

    // -----------------------------
    // 1. Gestion du clic sur les items principaux
    // -----------------------------
    accessButtons.forEach((button, index) => {
      button.addEventListener('click', () => {

        document.querySelector('.access__item.selected')?.classList.remove('selected');
        button.classList.add('selected');

        const newPosition = window.innerWidth > 1200 ? positions[index] : positionsResponsive[index];
        chevron.style.left = `${newPosition}px`;

        updateAccessBodiesState(index);

        updateTabOrder();
        scheduleAccessMainHeightUpdate();
      });

      button.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          button.click();
        }
      });
    });

    // -----------------------------
    // 2. Empêcher les liens vides de remonter la page
    // -----------------------------
    document.querySelectorAll('a[href="#"]').forEach(link => {
      link.addEventListener('click', e => e.preventDefault());
    });

    // -----------------------------
    // 3. Formater les titres de blocs (séparation du 1er mot)
    // -----------------------------
    document.querySelectorAll('.access .bloc__title').forEach(title => {
      const words = title.textContent.trim().split(' ');
      if (words.length > 1) {
        title.innerHTML = `<span>${words[0]}</span> ${words.slice(1).join(' ')}`;
      }
    });

    // -----------------------------
    // 4. Gestion responsive
    // -----------------------------
    if (window.innerWidth < 961 && accessHead) {
      accessHead.addEventListener('click', () => {
        accessHead.classList.toggle('access__head--open');
      });

      const accessItems = document.querySelectorAll('.access__item');
      accessItems.forEach(item => {
        item.addEventListener('click', () => {
          accessHead.classList.toggle('access__item--open');
        });
      });
    }

    // -----------------------------
    // 5. Gestion de l’ordre de tabulation (accessibilité)
    // -----------------------------
    function updateTabOrder() {
      // Désactive tous les éléments focusables
      document.querySelectorAll('.access a, .access button, .access [tabindex]').forEach(el => {
        el.setAttribute('tabindex', '-1');
      });

      // Active les 3 items principaux
      document.querySelectorAll('.access__item > a').forEach(a => {
        a.setAttribute('tabindex', '0');
      });

      // Active les sous-items du bloc ouvert uniquement
      const openBody = document.querySelector('.access__body--open');
      if (openBody) {
        openBody.querySelectorAll('.bloc a, .bloc__wrapper').forEach(a => {
          a.setAttribute('tabindex', '0');
        });
      }
    }

    const initialOpenIndex = Array.from(accessBodies).findIndex(body =>
      body.classList.contains('access__body--open')
    );
    updateAccessBodiesState(initialOpenIndex === -1 ? 0 : initialOpenIndex);
    updateTabOrder();
    scheduleAccessMainHeightUpdate();
    window.addEventListener('resize', scheduleAccessMainHeightUpdate);

  });


  // image random map
  document.addEventListener('DOMContentLoaded', () => {
    const hero = document.querySelector('.hero');
    if(!hero) return;

    const images = JSON.parse(hero.dataset.images);
    const randomImage = images[Math.floor(Math.random() * images.length)];
    hero.style.setProperty('--bg', `url('${randomImage}')`);
  });

// Script pour le select menu responsive (< 961px)
if (window.innerWidth < 961) {
  const mapMenu = document.querySelector('.map__menu');
  const redirectBtn = document.querySelector('.map__redirect');
  const links = mapMenu.querySelectorAll('.map__link');

  // Quand on clique sur un lien dans le menu
  links.forEach(link => {
    link.addEventListener('click', (e) => {
      // Si le menu est fermé > on empêche la redirection et on ouvre
      if (!mapMenu.classList.contains('opened')) {
        e.preventDefault();
        mapMenu.classList.add('opened');
      } else {
        // Si le menu est ouvert > on change la sélection
        e.preventDefault();
        links.forEach(l => l.parentElement.classList.remove('selected'));
        link.parentElement.classList.add('selected');
        mapMenu.classList.remove('opened');
      }
    });
  });

  // Quand on clique sur "OK", on redirige vers le lien sélectionné
  redirectBtn.addEventListener('click', () => {
    const selectedLink = mapMenu.querySelector('.map__item.selected .map__link');
    if (selectedLink) {
      window.location.href = selectedLink.href;
    }
  });
}

}

// Weather popup 
if(home) {
    const meteoBtn = document.querySelector('.header__meteo-btn');
    meteoBtn.addEventListener('click', meteoPopup);

    function meteoPopup() {
        const meteoPopup = document.querySelector('.weather');
        meteoPopup.classList.toggle('hidden');
    }

    const meteoClose = document.querySelector('.weather__close');
    meteoClose.addEventListener('click', meteoClosePopup);

    function meteoClosePopup() {
        const meteoPopup = document.querySelector('.weather');
        meteoPopup.classList.add('hidden');
    }
}

// Menu Burger dynamic height
const burgerNav = document.querySelector('.nav-main--burger');
const menuBg = document.querySelector('.nav-main--burger__popup');
const mainMenu = document.querySelector('.nav-main--burger__container');

if (burgerNav && menuBg && mainMenu) {
  const HEIGHT_OFFSET = 190;
  const toggleButtons = [
    document.querySelector('#js-OpenMenu'),
    document.querySelector('#js-CloseMenu'),
    document.querySelector('#js-CloseMenuA11y'),
    document.querySelector('#js-CloseSubmenu'),
  ].filter(Boolean);
  let cleanupTimeout = null;
  let baseMenuHeight = null;

  const clearInlineHeights = () => {
    if (burgerNav.classList.contains('js-open-menu')) {
      return;
    }
    menuBg.style.height = '';
    menuBg.style.minHeight = '';
  };

  const toMs = value => {
    const numeric = parseFloat(value);
    if (Number.isNaN(numeric)) {
      return 0;
    }
    return value.trim().endsWith('ms') ? numeric : numeric * 1000;
  };

  const scheduleCleanup = () => {
    if (cleanupTimeout) {
      clearTimeout(cleanupTimeout);
    }
    const style = window.getComputedStyle(menuBg);
    const durations = style.transitionDuration.split(',').map(toMs);
    const delays = style.transitionDelay.split(',').map(toMs);
    const total = durations.reduce((max, duration, index) => {
      const delay = delays[index] || delays[delays.length - 1] || 0;
      return Math.max(max, duration + delay);
    }, 0);

    cleanupTimeout = window.setTimeout(clearInlineHeights, total || 0);
  };

  menuBg.addEventListener('transitionend', event => {
    if (event.target === menuBg && event.propertyName === 'height') {
      clearInlineHeights();
    }
  });

  const applyHeights = () => {
    const isMenuOpen = burgerNav.classList.contains('js-open-menu');
    const rawMenuHeight = Math.ceil(mainMenu.scrollHeight);
    const activeSubmenu = burgerNav.querySelector('.menu__item.js-open-submenu .submenu');
    const rawSubmenuHeight = activeSubmenu ? Math.ceil(activeSubmenu.scrollHeight) : 0;
    const hasActiveSubmenu = Boolean(activeSubmenu);

    if (rawMenuHeight > 0) {
      if (!hasActiveSubmenu) {
        baseMenuHeight = rawMenuHeight;
      } else if (baseMenuHeight === null) {
        baseMenuHeight = Math.max(rawMenuHeight - rawSubmenuHeight, 0);
      }
    }

    const resolvedBaseHeight = (baseMenuHeight !== null ? baseMenuHeight : rawMenuHeight) + HEIGHT_OFFSET;
    const submenuHeightWithOffset = rawSubmenuHeight > 0 ? rawSubmenuHeight + HEIGHT_OFFSET : 0;
    const targetHeight = hasActiveSubmenu
      ? Math.max(resolvedBaseHeight, submenuHeightWithOffset)
      : resolvedBaseHeight;

    // menuBg.style.minHeight = `${resolvedBaseHeight}px`;
    menuBg.style.minHeight = `470px`;

    if (!isMenuOpen) {
      menuBg.style.height = `${resolvedBaseHeight}px`;
      scheduleCleanup();
      return;
    }

    menuBg.style.height = `${targetHeight}px`;
    if (cleanupTimeout) {
      clearTimeout(cleanupTimeout);
      cleanupTimeout = null;
    }
  };

  const scheduleUpdate = () => requestAnimationFrame(applyHeights);

  toggleButtons.forEach(button => {
    button.addEventListener('click', scheduleUpdate);
  });

  burgerNav.addEventListener('click', event => {
    const toggle = event.target.closest('.menu-item-has-children > .menu__link, #js-CloseSubmenu');
    if (toggle) {
      scheduleUpdate();
    }
  });

  window.addEventListener('resize', scheduleUpdate);

  const elementsToObserve = [mainMenu, ...burgerNav.querySelectorAll('.submenu')];

  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(scheduleUpdate);
    elementsToObserve.forEach(element => resizeObserver.observe(element));
  }

  scheduleUpdate();
}


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})
